// reducers/index.js

import { combineReducers }                  from 'redux';
import { default as pubSubReducer  }        from './pubsub/index';
import { default as catalogReducer }        from './catalog/index';
import { default as passwordReducer }       from './password/index';
import { default as coreReducer }           from './core/index';
import { default as chatReducer }           from './chat/index';
import { default as doorReducer }           from './door/index';
import { default as authReducer }           from './auth/index';
import { default as employeeReducer }       from './employee-onboarding/index';
import { default as jokeReducer }           from './joke/index';
import { default as systemsReducer }        from './systems/index';
import { default as testMReducer }          from './test-maintenance/index';
import { default as connectReducer }        from './connect/index';

export default combineReducers({
    pubsub         : pubSubReducer,
    catalog        : catalogReducer,
    password       : passwordReducer,
    core           : coreReducer,
    chat           : chatReducer,
    door           : doorReducer,
    auth           : authReducer,
    employee       : employeeReducer,
    joke           : jokeReducer,
    systems        : systemsReducer,
    testM          : testMReducer,
    connect        : connectReducer
});